import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from "../ui/dialog";
import { Button } from "../ui/button";

interface DeleteCompanyDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  companyName?: string;
}

export const DeleteCompanyDialog: React.FC<DeleteCompanyDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  companyName
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Delete Finance Company</DialogTitle>
        </DialogHeader>
        <div className="py-4 space-y-3">
          <p className="text-sm text-slate-600 leading-relaxed">
            Are you sure you want to delete <span className="font-semibold text-slate-900">{companyName || "this company"}</span>? This action is <span className="font-semibold text-red-600">permanent</span> and cannot be undone.
          </p>
          <p className="text-sm text-slate-400 italic">
            You can only delete companies that are not currently associated with any active direct debit records.
          </p>
        </div>
        <DialogFooter className="flex gap-2">
          <DialogClose asChild>
            <Button variant="outline" className="flex-1">Cancel</Button>
          </DialogClose>
          <Button 
            variant="destructive" 
            onClick={onConfirm}
            className="flex-1 shadow-sm font-bold"
          >
            Confirm Deletion
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
